export default function polishPlural(
  value: number,
  singularNominative: string,
  pluralNominative: string,
  pluralGenitive = pluralNominative
) {
  return value === 1
    ? singularNominative
    : value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20)
    ? pluralNominative
    : pluralGenitive
}
